import React from 'react';
import { Card, Form } from 'react-bootstrap-5';

export type CallListUser = {
  name: string;
  id: number;
  onList: boolean;
  currentUser: boolean;
}

type ManageCallListUsersProps = {
  users: CallListUser[];
  checkedUsers: number[];
  setCheckedUsers: React.Dispatch<React.SetStateAction<number[]>>;
}

export default function ManageCallListUsers({ users, checkedUsers, setCheckedUsers }: ManageCallListUsersProps) {
  const handleUserCheck = (id: number) => {
    if (checkedUsers.includes(id)) {
      setCheckedUsers(prev => prev.filter(userId => userId !== id));
    } else {
      setCheckedUsers(prev => [...prev, id]);
    }
  };

  const handleSelectAll = () => {
    if (checkedUsers.length === users.length) {
      setCheckedUsers(users.filter(user => user.currentUser).map(user => user.id));
    } else {
      setCheckedUsers(users.map(user => user.id));
    }
  };


  return (
    <Card className="mb-5 shadow">
      <Card.Header className="bg-light rounded p-2">
        <Form.Check
          checked={checkedUsers.length === users.length}
          className="d-flex gap-1 align-items-center"
          id="manager-select-all-users"
          label="Select All"
          type="checkbox"
          onChange={handleSelectAll}
        />
      </Card.Header>
      <Card.Body className="p-2">
        {
          users.map(user => (
            <Form.Check
              checked={checkedUsers.includes(user.id)}
              className="d-flex gap-1 align-items-center"
              disabled={user.currentUser}
              id={`manager-user-${user.id}`}
              key={user.id}
              label={user.name}
              type="checkbox"
              onChange={() => handleUserCheck(user.id)}
            />
          ))
        }
      </Card.Body>
    </Card>
  );

}
